import React from 'react'
import Dashboard from '../Dashboard';
import TransactionsSuccessMain from './TransactionsSuccessMain'

export default function TransactionsSuccess() {
    return (
        <div>
            <Dashboard cmp={<TransactionsSuccessMain />} />
        </div>
    )
}
